import { TextCSSStyle, TextCSSStyleImpl } from '../textcss';
import { Fonts } from '../../../../utils/resources/fonts';
import { Colors } from '../../../../utils/resources/colors';
export interface MsisdnTextCSSStyle extends TextCSSStyle
{
    getCountryCodeCSSStyle(): object;
}

export class MsisdnTextCSSStyleImpl extends TextCSSStyleImpl implements MsisdnTextCSSStyle
{
    getWrapperCSSStyle(): object 
    {
        return {
            display: "flex",
            position: "relative",
            flexDirection: "column",
            marginTop: "0px",
            width:'100%'
        };
    }
    getCountryCodeCSSStyle(): object {
        return {
         fontSize: this.getResources().getFont(Fonts.h7),
         color: "#959595",
         height: "40px",
         position: "absolute",
         textDecoration: "none",
         border: 0,
         marginTop: "0px",
         marginLeft: "15px", 
         marginRight: "15px",
         fontWeight: 500,
         letterSpacing: 0,
         lineHeight: "40px",
         outline: "none"
        };
     }

    
    getTextCSSStyle(isFloatingLabel: boolean, isDisabled:boolean): object 
    {
       
            return {
                fontSize: this.getResources().getFont(Fonts.h7),
                backgroundColor:isDisabled? this.getResources().getColor(Colors.color_17):this.getResources().getColor(Colors.color_5),
                color: this.getResources().getColor(Colors.color_4),
                height: "40px",
                // bottom: "3px",
                boxSizing: "border-box",
                textDecoration: "none",
                fontWeight: 500,
                letterSpacing: 0,
                lineHeight: "40px",
                width:'100%',
                borderRadius:'35px',
                border:'1px solid'+this.getResources().getColor(Colors.color_8),
                outline: "none",
            };
    }
    getErrorCSSStyle(): object {
        return {
            fontSize: this.getResources().getFont(Fonts.h7),
            color: this.getResources().getColor(Colors.color_4),
            height: "40px",
            // bottom: "3px",
            width:'100%',
            textDecoration: "none",
            fontWeight: 500,
            letterSpacing: 0,
            lineHeight: "40px",
            borderRadius:'35px',
            border:'1px solid '+this.getResources().getColor(Colors.color_8),
            outline: "none",
            backgroundColor: this.getResources().getColor(Colors.color_5),
            boxSizing: "border-box",
            // borderLeft: "2px solid " + this.getResources().getColor(Colors.color_12),
        };
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/text/msisdntext/msisdntextcss.tsx